import { render, staticRenderFns } from "./RequestsEditor.vue?vue&type=template&id=00978a59&scoped=true"
import script from "./RequestsEditor.vue?vue&type=script&lang=js"
export * from "./RequestsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00978a59",
  null
  
)

export default component.exports